import { LandingLayoutDefaultContent } from '@doltech/ui/lib/figma/Layout/Landing/PremadeLayout/LandingLayoutDefault';

import * as React from 'react';

export const CommonLayout = (props: any) => <LandingLayoutDefaultContent {...props} loading />;
